import { createContext, useContext } from "react"

export const blogPosts = [
  {
    id: 1,
    image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753430557/shouk_qcnj3c.png",
    title: {
      he: "סיור קולינרי בשוק מחנה יהודה",
      en: "Culinary Tour in Mahane Yehuda Market",
      fr: "Tour Culinaire au Marché Mahane Yehuda",
      es: "Tour culinario en el mercado Mahane Yehuda"
    },
    category: {
      he: "אוכל",
      en: "Food",
      fr: "Cuisine",
      es: "Comida"
    },
    summary: {
      he: "הכירו את הדוכנים, המסעדות והטעמים הכי מיוחדים בלב השוק הססגוני של ירושלים.",
      en: "Discover the best stalls, restaurants, and flavors in the vibrant heart of Jerusalem's market.",
      fr: "Découvrez les meilleurs stands, restaurants et saveurs au cœur du marché animé de Jérusalem.",
      es: "Descubre los mejores puestos, restaurantes y sabores en el vibrante mercado de Jerusalén."
    },
    content: {
      he: "שוק מחנה יהודה הוא גן עדן לאוהבי אוכל. בין הדוכנים תמצאו מאפים טריים, גבינות בוטיק, מסעדות שף ומגוון ברים תוססים. מומלץ להצטרף לסיור מודרך או פשוט לשוטט ולגלות את הטעמים בעצמכם.",
      en: "Mahane Yehuda Market is a paradise for foodies. Enjoy fresh pastries, boutique cheeses, chef restaurants, and lively bars. Join a guided tour or wander and discover the flavors yourself.",
      fr: "Le marché Mahane Yehuda est un paradis pour les gourmets. Pâtisseries fraîches, fromages artisanaux, restaurants de chefs et bars animés vous attendent. Rejoignez une visite guidée ou explorez à votre rythme.",
      es: "El mercado Mahane Yehuda es un paraíso para los amantes de la comida. Disfruta de pasteles frescos, quesos boutique, restaurantes de chefs y bares animados. Únete a un tour guiado o explora por tu cuenta."
    },
    details: {
      he: {
        address: "רחוב אגריפס 90, ירושלים",
      },
      en: {
        address: "90 Agrippas St, Jerusalem",
      },
      fr: {
        address: "90 Agrippas St, Jerusalem",
      },
      es: {
        address: "90 Agrippas St, Jerusalem",
      }
    },
    links: {
      googleMaps: "https://www.google.com/maps/place/%D7%A9%D7%95%D7%A7+%D7%9E%D7%97%D7%A0%D7%94+%D7%99%D7%94%D7%95%D7%93%D7%94%E2%80%AD/data=!4m2!3m1!1s0x0:0xe1566ca192ce80f?sa=X&ved=1t:2428&ictx=111",
    }
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753430355/helen_tqrav0.png",
    title: {
    he: "מאפיית Helen",
    en: "Helen's Bakery",
    fr: "La boulangerie Helen",
    es: "La panadería Helen"
  },
    category: {
      he: "אוכל",
      en: "Food",
      fr: "Cuisine",
      es: "Comida"
    },
    summary: {
    he: "מאפיית בוטיק משפחתית בלב ירושלים עם ניחוחות פריזאיים וטעמים טוניסאיים – כשרה למהדרין.",
    en: "A boutique family-run bakery in the heart of Jerusalem offering Parisian aromas and Tunisian flavors – strictly kosher.",
    fr: "Une boulangerie familiale de style boutique au cœur de Jérusalem, avec des parfums parisiens et des saveurs tunisiennes – strictement cachère.",
    es: "Una panadería familiar tipo boutique en el corazón de Jerusalén, con aromas parisinos y sabores tunecinos – kosher mehadrin."
  },
    content: {
    he: "מאפיית Helen היא פטיסרי כשרה למהדרין הממוקמת ברחוב אגריפס 6, מול שוק מחנה יהודה בירושלים. המאפייה מנוהלת על ידי משפחת ג׳ורנו, שעלתה לישראל מפריז ומטוניס בשנות ה־80, ומשלבת מסורת צרפתית עם טעמים צפון אפריקאים.\n\nבתפריט תמצאו קרואסונים חמאה, פאן או שוקולה, מילפיי, עוגות שוקולד ואגוזים, קינוחי קרם ברולה לצד מנות מלוחות כמו סנדוויץ' טוניסאי אותנטי, פוקאצ׳ות, סלטים ושתייה חמה וקרה.",
    
    en: "Helen's Bakery is a boutique kosher patisserie located at 6 Agrippas Street, directly opposite Jerusalem's Mahane Yehuda Market. Run by the Journo family, originally from Paris and Tunis, the bakery fuses classic French pastry techniques with North African flair.\n\nOn the menu: buttery croissants, pain au chocolat, mille-feuille, chocolate and nut cakes, crème brûlée desserts, as well as savory options like authentic Tunisian sandwiches, focaccias, fresh salads, hot and cold drinks.",
    
    fr: "La boulangerie Helen est une pâtisserie kasher située au 6 rue Agripas, en face du marché Mahane Yehuda à Jérusalem. Gérée par la famille Journo, originaire de Paris et de Tunis, elle allie pâtisserie française et saveurs nord-africaines.\n\nAu menu : croissants, pain au chocolat, mille-feuille, gâteaux aux noix et chocolat, crème brûlée, sandwichs tunisiens, focaccias, salades fraîches, boissons chaudes et froides.",
    
    es: "La panadería Helen es una pastelería kosher ubicada en la calle Agripas 6, frente al mercado Majané Yehuda de Jerusalén. Administrada por la familia Journo, proveniente de París y Túnez, combina la repostería francesa clásica con sabores del norte de África.\n\nEn el menú: croissants, pain au chocolat, mille-feuille, pasteles de chocolate y nueces, crème brûlée, sándwiches tunecinos, focaccias, ensaladas frescas, bebidas calientes y frías."
  },
    details: {
    address: "רחוב אגריפס 6, ירושלים",
    addressEn: "6 Agrippas St, Jerusalem",
    addressFr: "6 rue Agripas, Jérusalem",
    addressEs: "6 Agrippas St, Jerusalén",
    phone: "02-9666406",
    kosher: "בד\"ץ מהדרין ירושלים",
    hours: {
      he: {
        "א-ה": "08:00–16:00\u00a0",
        "ו'": "\u00a008:00–13:00",
        "שבת": "\u00a0סגור"
      },
      en: {
        "Sun–Thu": "\u00a008:00 AM–4:00 PM",
        "Fri": "\u00a008:00 AM–1:00 PM",
        "Sat": "\u00a0Closed"
      },
      fr: {
        "dim.–jeu.": "\u00a008h00–16h00",
        "ven.": "\u00a008h00–13h00",
        "sam.": "\u00a0Fermé"
      },
      es: {
        "dom.–jue.": "\u00a008:00–16:00",
        "vie.": "\u00a008:00–13:00",
        "sáb.": "\u00a0Cerrado"
      }
    }
  },
    links: {
    instagram: "https://www.instagram.com/helenbakers.jr",
    googleMaps: "https://www.google.com/maps?q=Helen+Family+Bakers,+Agripas+6,+Jerusalem",
  }
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753430751/yemin-moshe_otkd4n.png",
    title: {
      he: "סיור רומנטי בימין משה",
      en: "Romantic Walk in Yemin Moshe",
      fr: "Balade romantique à Yemin Moshe",
      es: "Paseo romántico en Yemin Moshe"
    },
    category: {
      he: "אתרים",
      en: "Attractions",
      fr: "Attractions",
      es: "Atracciones"
    },
    summary: {
      he: "שכונה ציורית וקסומה מול העיר העתיקה – מושלמת לטיול זוגי או צילום.",
      en: "A picturesque neighborhood facing the Old City – perfect for a romantic stroll or photography.",
      fr: "Un quartier pittoresque face à la vieille ville – idéal pour une promenade romantique ou des photos.",
      es: "Un barrio pintoresco frente a la Ciudad Vieja – ideal para un paseo romántico o fotografías."
    },
    content: {
      he: "ימין משה היא אחת השכונות הראשונות מחוץ לחומות, עם רחובות אבן, פריחה צבעונית ונוף מרהיב לחומות. המקום מושלם לטיולים שקטים בשקיעה, והוא צמוד לתיאטרון החאן וגן הפעמון.",
      en: "Yemin Moshe is one of the first neighborhoods built outside Jerusalem’s walls, featuring cobblestone alleys, colorful flowers, and stunning views of the Old City. Ideal for an evening walk near Khan Theatre and Bell Park.",
      fr: "Yemin Moshe est l’un des premiers quartiers hors des murs de Jérusalem. Rues pavées, fleurs et vues sublimes en font un lieu parfait pour se promener près du théâtre Khan et du parc de la Cloche.",
      es: "Yemin Moshe fue uno de los primeros barrios fuera de las murallas. Sus calles, flores y vistas son ideales para una caminata cerca del teatro Khan y del parque de la Campana."
    },
    details: {
      address: "שכונת ימין משה, ירושלים",
      addressEn: "Yemin Moshe, Jerusalem",
      addressFr: "Yemin Moshe, Jérusalem",
      addressEs: "Yemin Moshe, Jerusalén"
    },
    links: {
      googleMaps: "https://www.google.com/maps?q=yemin+moshe+jerusalem"
    }
  },
  {
    id: 4,
    image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753430902/museum_xt2gxk.png",
    title: {
      he: "מוזיאון ישראל",
      en: "Israel Museum",
      fr: "Musée d'Israël",
      es: "Museo de Israel"
    },
    category: {
      he: "תרבות",
      en: "Culture",
      fr: "Culture",
      es: "Cultura"
    },
    summary: {
      he: "המוזיאון הגדול והמרשים בישראל – אמנות, היסטוריה ותרבות לכל הגילאים.",
      en: "Israel’s largest and most impressive museum – art, history, and culture for all ages.",
      fr: "Le plus grand musée d’Israël – art, histoire et culture pour tous les âges.",
      es: "El museo más grande e impresionante de Israel – arte, historia y cultura para todos."
    },
    content: {
      he: "במוזיאון ישראל תוכלו למצוא את מגילות ים המלח, מודל ירושלים מימי הבית השני, אגף נוער פעיל ואוסף אמנות ישראלית ובינלאומית. חוויה לכל המשפחה.",
      en: "The Israel Museum houses the Dead Sea Scrolls, a model of Second Temple Jerusalem, a vibrant youth wing, and a broad collection of Israeli and international art.",
      fr: "Le Musée d’Israël abrite les manuscrits de la mer Morte, une maquette de Jérusalem antique, un espace jeunesse dynamique, et une riche collection d’art israélien et international.",
      es: "El Museo de Israel alberga los rollos del Mar Muerto, una maqueta de Jerusalén antigua, un ala infantil interactiva y una colección amplia de arte."
    },
    details: {
      address: "שדרות רופין 11, ירושלים",
      addressEn: "11 Ruppin Blvd, Jerusalem",
      addressFr: "11 rue Ruppin, Jérusalem",
      addressEs: "11 Ruppin Blvd, Jerusalén",
      phone: "02-670-8811",
      hours: {
        he: {
          "א-ה": "\u00a010:00–17:00",
          "ו'": "\u00a010:00–14:00",
          "שבת": "\u00a010:30–16:00"
        },
        en: {
          "Sun–Thu": "\u00a010:00 AM–5:00 PM",
          "Fri": "\u00a010:00 AM–2:00 PM",
          "Sat": "\u00a010:30 AM–4:00 PM"
        },
        fr: {
          "dim.–jeu.": "\u00a010h00–17h00",
          "ven.": "\u00a010h00–14h00",
          "sam.": "\u00a010h30–16h00"
        },
        es: {
          "dom.–jue.": "\u00a010:00–17:00",
          "vie.": "\u00a010:00–14:00",
          "sáb.": "\u00a010:30–16:00"
        }
      }
    },
    links: {
      website: "https://www.imj.org.il/en",
      googleMaps: "https://www.google.com/maps?q=israel+museum+jerusalem"
    }
  },
  {
    id: 5,
    image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753431021/bell_nlds6g.png",
    title: {
      he: "גן הפעמון",
      en: "Bell Garden",
      fr: "Parc de la Cloche",
      es: "Parque de la Campana"
    },
    category: {
      he: "טבע",
      en: "Nature",
      fr: "Nature",
      es: "Naturaleza"
    },
    summary: {
      he: "פארק עירוני רחב ידיים מושלם לפיקניק, משחק עם ילדים או הליכה רגועה.",
      en: "A wide urban park, perfect for a picnic, family playtime or a relaxed walk.",
      fr: "Un grand parc urbain idéal pour un pique-nique, une promenade ou jouer avec les enfants.",
      es: "Un gran parque urbano ideal para picnic, juegos infantiles o un paseo relajado."
    },
    content: {
      he: "גן הפעמון ממוקם בלב ירושלים, קרוב לימין משה ולמתחם התחנה. יש בו מדשאות מוצלות, מתקני משחק, מסלולי ריצה ופינות ישיבה שקטות – מקום מושלם להירגע בין האתרים.",
      en: "Located near Yemin Moshe and the First Station, Bell Park offers shaded lawns, playgrounds, jogging paths, and quiet corners to relax in between sightseeing.",
      fr: "Situé près de Yemin Moshe et de la Première Gare, ce parc offre des pelouses, des jeux, des sentiers et des espaces calmes pour se détendre.",
      es: "Cerca de Yemin Moshe y la Primera Estación, el parque ofrece césped, juegos infantiles, caminos y rincones tranquilos para descansar."
    },
    details: {
      address: "רחוב המלך דוד, ירושלים",
      addressEn: "King David St, Jerusalem",
      addressFr: "Rue King David, Jérusalem",
      addressEs: "King David St, Jerusalén"
    },
    links: {
      googleMaps: "https://www.google.com/maps?q=bell+park+jerusalem"
    }
  },
  {
  id: 6,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753431284/wall2_vsyj4c.png",
  title: {
    he: "ביקור בכותל המערבי",
    en: "Visiting the Western Wall",
    fr: "Visite du Mur Occidental",
    es: "Visita al Muro Occidental"
  },
  category: {
    he: "תרבות",
    en: "Culture",
    fr: "Culture",
    es: "Cultura"
  },
  summary: {
    he: "הכותל המערבי הוא המקום הקדוש ביותר לעם היהודי, מושך אליו מבקרים מרחבי העולם לתפילה, התבוננות וחיבור רוחני.",
    en: "The Western Wall is the holiest site for the Jewish people, attracting visitors from around the world for prayer, reflection, and spiritual connection.",
    fr: "Le Mur Occidental est le site le plus sacré pour le peuple juif, attirant des visiteurs du monde entier pour prier, méditer et se connecter spirituellement.",
    es: "El Muro Occidental es el lugar más sagrado para el pueblo judío, atrayendo visitantes de todo el mundo para orar, reflexionar y conectarse espiritualmente."
  },
  content: {
    he: "הכותל המערבי הוא שריד בית המקדש השני וממוקם ברובע היהודי בעיר העתיקה של ירושלים. המבקרים במקום יכולים לשים פתק עם תפילה בין אבני הכותל, להשתתף בסיורים מודרכים, ולחוות את עוצמת ההיסטוריה והקדושה. מומלץ להגיע בשעות הבוקר או לפנות ערב כדי לחוות את האווירה בצורה רגועה ומרשימה.",
    en: "The Western Wall is a remnant of the Second Temple and is located in the Jewish Quarter of Jerusalem’s Old City. Visitors can place prayer notes between the stones, join guided tours, and experience the power of history and holiness. Morning or evening visits are recommended for a more peaceful and spiritual atmosphere.",
    fr: "Le Mur Occidental est un vestige du Second Temple et se situe dans le quartier juif de la vieille ville de Jérusalem. Les visiteurs peuvent glisser des prières entre les pierres, participer à des visites guidées et ressentir la puissance de l’histoire et de la sainteté. Il est recommandé de venir le matin ou en soirée pour une ambiance plus calme et spirituelle.",
    es: "El Muro Occidental es un vestigio del Segundo Templo y está ubicado en el barrio judío de la Ciudad Vieja de Jerusalén. Los visitantes pueden colocar notas de oración entre las piedras, unirse a visitas guiadas y experimentar la fuerza de la historia y la santidad. Se recomienda visitarlo por la mañana o al atardecer para una atmósfera más tranquila y espiritual."
  },
  details: {
    address: "רחבת הכותל, העיר העתיקה, ירושלים",
    addressEn: "Western Wall Plaza, Old City, Jerusalem",
    addressFr: "Parc du Mur Occidental, Old City, Jerusalem",
    addressEs: "Parque del Muro Occidental, Old City, Jerusalén",
    hours: {
      he: {
       "פתוח בכל יום":"24/7\u00a0"
      },
      en: {
        "Open\u00a0":"24/7"
      },
      fr: {
        "Ouvert\u00a0":"24/7"
      },
      es: {
        "Abierto\u00a0":"24/7"
      }
    }
  },
  links: {
    googleMaps: "https://www.google.com/maps?q=Western+Wall,+Jerusalem",
  }
},
{
  id: 7,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753432655/black-iron_aubj4z.png",
  title: {
    he: "Black Iron – סטייקים כשרים בסגנון ניו־יורקי",
    en: "Black Iron – Kosher New‑York Style Steaks",
    fr: "Black Iron – Steaks cacher style new‑yorkais",
    es: "Black Iron – Bistecs kosher estilo neoyorquino"
  },
  category: {
    he: "אוכל",
    en: "Food",
    fr: "Cuisine",
    es: "Comida"
  },
  summary: {
    he: "סטייקהאוס כשר קרוב לשוק מחנה יהודה, המתמחה בבשר משובח ובצלעות עסיסיות.",
    en: "A kosher steakhouse near Mahane Yehuda Market, specializing in high‑quality cuts and juicy ribs.",
    fr: "Un steakhouse cacher près du marché Mahane Yehuda, spécialisé dans les viandes haut de gamme et les côtes juteuses.",
    es: "Un steakhouse kosher cerca del mercado Mahane Yehuda, especializado en carnes de alta calidad y costillas jugosas."
  },
  content: {
    he: "Black Iron מציע חוויית סטייק כשרה במסעדה טרנדית על רחוב אגריפס – בשר איכותי ממשקים צפון ישראל, מנות ייחודיות כמו אסאדו קולסלאו וטארטר כתף. מקום מומלץ להזמנות מראש.",
    en: "Black Iron delivers a kosher steak experience on Agripas Street, using premium meat from northern Israeli farms. Dishes include asado coleslaw, rump tartare and house-aged steaks. Reservation advised.",
    fr: "Black Iron propose une expérience steakhouse cacher sur la rue Agripas, avec viandes haut de gamme provenant du nord d’Israël. Plats: asado coleslaw, tartare de rumsteak, steaks affinés maison.",
    es: "Black Iron ofrece experiencia steakhouse kosher en la calle Agripas, con carnes premium del norte de Israel. Platos: coleslaw asado, tartar de cadera y bistecs madurados en casa."
  },
  details: {
    address: "רחוב אגריפס 80, ירושלים",
    addressEn: "80 Agripas St, Jerusalem",
    addressFr: "80 rue Agripas, Jérusalem",
    addressEs: "80 Agripas St, Jerusalén"
  },
  links: {
    instagram: "https://www.instagram.com/blackiron.bar/",
    website: "https://www.blackiron.co.il/",
    googleMaps: "https://www.google.com/maps?q=Black+Iron+Jerusalem"
  }
},
{
  id: 8,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753604963/jackosstreet_xexwgf.png",
  title: {
    he: "Jacko’s Street – שף כשר בשוק מחנה יהודה",
    en: "Jacko’s Street – Kosher Chef Restaurant at Mahane Yehuda",
    fr: "Jacko’s Street – Restaurant casher de chef au marché Mahane Yehuda",
    es: "Jacko’s Street – Restaurante casher de chef en el mercado Mahane Yehuda"
  },
  category: {
    he: "אוכל",
    en: "Food",
    fr: "Cuisine",
    es: "Comida"
  },
  summary: {
    he: "מסעדת שף כשרה עם תפריט יצירתי, אווירה תוססת ועיצוב אורבני בסמוך לשוק מחנה יהודה.",
    en: "A kosher chef‑driven restaurant with creative cuisine, vibrant atmosphere and urban design next to Mahane Yehuda Market.",
    fr: "Un restaurant casher de chef proposant une cuisine créative, une ambiance animée et un décor urbain près du marché Mahane Yehuda.",
    es: "Un restaurante casher de autor con cocina creativa, ambiente vibrante y diseño urbano junto al mercado Mahane Yehuda."
  },
  content: {
    he: "Jacko’s Street נוסדה ב־2013 על ידי השף זקאי חוג׳ה והשותפים רפי רביבו ויוטם ניסים, ונחשבת למסעדה השף הכשרה הראשונה בשכונת השוק של ירושלים. המסעדה מתמחה במנות כמו רביולי כורדי, פיקציות של טונה ופרוסות אסאדו על לחם challah – כל זאת תוך דגש על חומר גלם מהשוק הסמוך ואווירה אורבנית מקורית. המקום עבר שדרוג עיצובי בשנת 2024 ושומר על שילוב של חלונות גדולים, בר פתוח ומטבח שקוף.",
    en: "Launched in 2013 by chef Zakai Huja alongside partners Rafi Revivo and Yotam Nissim, Jacko’s Street was the first kosher chef restaurant in Jerusalem’s market area. Signature dishes include Kurdish ravioli, tuna fricassee bites, and asado bruschetta on challah – all made from local produce sourced directly from nearby stalls. The venue received a major interior overhaul in early 2024, retaining stone walls, reclaimed wood, and an open kitchen and bar.",
    fr: "Ouvert en 2013 par le chef Zakai Huja avec Rafi Revivo et Yotam Nissim, Jacko’s Street fut la première adresse de chef cacher dans le quartier du marché. Plats signatures : raviolis kurdes, fricassée de thon, bruschetta d’asado sur challah – élaborés avec produits du shuk. Le lieu a été rénové en 2024, tout en conservant ses murs en pierre, son bar ouvert et sa cuisine à visibilité.",
    es: "Inaugurado en 2013 por el chef Zakai Huja junto con Rafi Revivo y Yotam Nissim, Jacko’s Street fue el primer restaurante kosher de autor en el barrio del mercado de Jerusalem. Platos emblemáticos: ravioli kurdo, fricasé de atún y bruschetta de asado en challah – todos con productos frescos del shuk. El local fue renovado en 2024, manteniendo muros de piedra, bar abierto y cocina visible."
  },
  details: {
    address: "רחוב אגריפס 74, ירושלים",
    addressEn: "74 Agripas St, Jerusalem",
    phone: "02-581-7178",
    kosher: "בד\"ץ ירושלים מהדרין",
    hours: {
      he: {
        "א-ה": "11:00–16:00, 17:00–עד הלקוח האחרון",
        "ו'": "11:00–15:00",
        "שבת": "פתוח שעה לאחר צאת שבת עד לסוף פעולת המקום"
      },
      en: {
        "Sun–Thu": "11:00–16:00, 17:00–late",
        "Fri": "11:00–15:00",
        "Sat": "\u00a0From 1 hour after Shabbat until late"
      },
      fr: {
        "dim.–jeu.": "11h00–16h00, 17h00– tard",
        "ven.": "11h00–15h00",
        "sam.": "1 heure après le Shabbat tard"
      },
      es: {
        "dom.–jue.": "11:00–16:00, 17:00– tarde",
        "vie.": "11:00–15:00",
        "sáb.": "1 hora después de Shabbat tarde"
      }
    }
  },
  links: {
    website: "https://jackosstreet.co.il/?lang=en",
    googleMaps: "https://www.google.com/maps?q=Jacko%27s+Street+Jerusalem",
  }
},
{
  id: 9,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753432568/azura_bbtk5e.png",
  title: {
    he: "עזורה – המטבח המזרחי של השוק",
    en: "Azura – The Market’s Middle Eastern Kitchen",
    fr: "Azura – La cuisine moyen-orientale du marché",
    es: "Azura – La cocina del Medio Oriente en el shuk"
  },
  category: {
    he: "אוכל",
    en: "Food",
    fr: "Cuisine",
    es: "Comida"
  },
  summary: {
    he: "מסעדה משפחתית ותיקה בשוק מחנה יהודה, עם מנות מזרחיות מקוריות כמו סופריטו וקובה.",
    en: "A long-established family restaurant in Mahane Yehuda Market specializing in authentic Mizrahi dishes like sofrito and kubbeh.",
    fr: "Un restaurant familial historique dans le marché Mahane Yehuda, spécialisé dans la cuisine mizrahi traditionnelle comme le sofrito et le kubbeh.",
    es: "Un restaurante familiar histórico en el shuk de Mahane Yehuda, especializado en platos mizrahí auténticos como sofrito y kubbeh."
  },
  content: {
    he: "אזורה פועלת מאז שנות ה־50 ומגישה מטעמים עיראקיים, טורקיים וסוריים: סופרטו מבושל לאט, קובה ממולאת, חצילים ממולאים ועוד מנות שמרגישות כמו בבית. אווירה חמימה ושולחנות משותפים.",
    en: "Operating since the 1950s, Azura serves Iraqi, Turkish and Syrian comfort food: slow-cooked beef sofrito, stuffed kubbeh, meat-stuffed eggplant, and more, in a homely, communal setting.",
    fr: "En activité depuis les années 1950, Azura propose des plats réconfortants irakiens, turcs et syriens : sofrito mijoté, kubbeh farci, aubergines farcies, servis dans une ambiance conviviale.",
    es: "En funcionamiento desde los años 50, Azura ofrece comida hogareña iraquí, turca y siria: sofrito cocido lentamente, kubbeh relleno y berenjenas rellenas, en un ambiente cálido y compartido."
  },
  details: {
    address: "האשכול 4, מחנה יהודה, ירושלים",
    addressEn: "4 Ha-Eshkol St, Jerusalem",
    addressFr: "4 Ha-Eshkol St, Jérusalem",
    addressEs: "4 Ha-Eshkol St, Jerusalén",
    phone: "02-623-5204",

  },
  links: {
    instagram: "https://www.instagram.com/azura_jerusalem/",
    googleMaps: "https://www.google.com/maps?q=Azura+Jerusalem"
  }
},
{
  id: 10,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753432790/ishtabah_de5l16.png",
  title: {
    he: "אישטבח – שומבורק כורדי איקוני",
    en: "Ishtabach – Iconic Kurdish Shamburak",
    fr: "Ishtabach – Shamburak kurde emblématique",
    es: "Ishtabach – El icónico shamburak kurdo"
  },
  category: {
    he: "אוכל",
    en: "Food",
    fr: "Cuisine",
    es: "Comida"
  },
  summary: {
    he: "מסעדה קטנה בשוק עם שומבורק כורדי במילוי בשר או צמחוני – מיוחד ומלא טעם.",
    en: "A small market eatery serving Kurdish shamburak stuffed with meat or vegetarian fillings – unique and flavorful.",
    fr: "Petit établissement du marché servant du shamburak kurde farci à la viande ou version végétarienne – unique et savoureux.",
    es: "Pequeño local en el mercado que sirve shamburak kurdo relleno de carne o vegetariano – sabroso y original."
  },
  content: {
    he: "אישטבאך התפרסמה בזכות השומבורק הכורדי – בצק ממולא בבשר או ירקות, אפוי בתנור כיפה. מקום קטן אך עם אווירה מאד מקומית וטעימה. אטמוספירה של דוכן שוק תוסס.",
    en: "Ishtabach became famous for its Kurdish shamburak – dough parcels filled with meat or vegetables, baked in a dome oven. Small venue but buzzing with local market energy and flavors.",
    fr: "Ishtabach est célèbre pour son shamburak kurde – pâte farcie à la viande ou légumes, cuite dans un four en dôme. Petit lieu mais ambiance de marché authentique et savoureuse.",
    es: "Ishtabach es conocido por su shamburak kurdo – masa rellena de carne o verduras horneada en horno de cúpula. Lugar pequeño con auténtico ambiente de mercado y mucho sabor."
  },
  details: {
    address: "בית יעקב 1, מחנה יהודה, ירושלים",
    addressEn: "1 Beit Ya'akov St, Jerusalem",
    addressFr: "1 Beit Ya'akov St, Jérusalem",
    addressEs: "1 Beit Ya'akov St, Jerusalén",
    phone: "02-623-2997"
  },
  links: {
    website: "https://www.ishtabach.co.il/",
    googleMaps: "https://www.google.com/maps?q=Ishtabach+Jerusalem"
  }
},
{
  id: 11,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753432882/crave_veks2v.png",
  title: {
    he: "Crave – סטריט פוד כשר עם טאץ' עולמי",
    en: "Crave – Kosher Street Food with a Global Twist",
    fr: "Crave – Street food cacher au style international",
    es: "Crave – Comida callejera kosher con toque global"
  },
  category: {
    he: "אוכל",
    en: "Food",
    fr: "Cuisine",
    es: "Comida"
  },
  summary: {
    he: "בר-מסעדה כשרה בפאבים של השוק – המבורגרים, טאקוס, שילובי מקסיקו וקוריאנש.",
    en: "A kosher street-food bar in the market – burgers, tacos, fusion of Mexican & Korean flavors.",
    fr: "Bar street-food cacher dans le marché – burgers, tacos, fusion mexicaine et coréenne.",
    es: "Bar de street‑food kosher en el mercado – hamburguesas, tacos, fusión mexicana y coreana."
  },
  content: {
    he: "Crave הוקמה על ידי שף ישראלי לשעבר של טי־ארה דרום. התפריט כולל רמאן־בורגר, טאקוס, נאצ’וס, וצ’יפס עם שמן כמהין – כל זאת בשילוב חדשני עם השתתפות אמנות גרפיטי. אווירה צעירה ויצירתית.",
    en: "Founded by an Israeli chef and former punk rocker, Crave offers ramen burgers, tacos, nachos and truffle fries – creatively blended with graffiti art décor. Innovative kosher fusion street food in a lively setting.",
    fr: "Fondée par un chef israélien ancien punk, Crave propose ramen burgers, tacos, nachos et frites à la truffe – décor graffiti et style créatif. Street food cacher innovant dans une ambiance animée.",
    es: "Fundado por un chef israelí ex punk, Crave ofrece ramen burger, tacos, nachos y papas con trufa – con decoración graffiti. Street food kosher innovador y animado."
  },
  details: {
    address: "מנחם אוסישקין 50, מחנה יהודה, ירושלים",
    addressEn: "50 Menachem Ussishkin St, Jerusalem",
    addressFr: "50 Menachem Ussishkin St, Jérusalem",
    addressEs: "50 Menachem Ussishkin St, Jerusalén",
    phone: "02-627-2830",
  },
  links: {
    instagram: "https://www.instagram.com/gotcrave/",
    website: "https://www.crave.co.il/",
    googleMaps: "https://www.google.com/maps?q=Crave+Jerusalem"
  }
},
{
  id: 12,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753434025/david-tower_ygpkuy.png",
  title: {
    he: "מוזיאון מגדל דוד",
    en: "Tower of David Museum",
    fr: "Musée de la Tour de David",
    es: "Museo Torre de David"
  },
  category: {
    he: "תרבות",
    en: "Culture",
    fr: "Culture",
    es: "Cultura"
  },
  summary: {
    he: "מוזיאון המציג את תולדות ירושלים, עם מיצגים מרשימים, מופעי אור וקול ותצפית פנורמית על העיר.",
    en: "A museum chronicling Jerusalem’s history, featuring immersive exhibits, light shows, and panoramic views of the city.",
    fr: "Un musée retraçant l’histoire de Jérusalem, avec des expositions immersives, spectacles son et lumière et vue panoramique sur la ville.",
    es: "Un museo que narra la historia de Jerusalén, con exposiciones inmersivas, shows de luz y sonido y vistas panorámicas de la ciudad."
  },
  content: {
    he: "במוזיאון מגדל דוד תמצאו תערוכות אינטראקטיביות על ערים קדומות, מופעי לילה אור־קולי וטיול סביב החומות עם תצפית עוצרת נשימה על העיר העתיקה והחדשה. מתאים גם למשפחות עם ילדים.",
    en: "At the Tower of David Museum you'll explore interactive exhibits about ancient cities, enjoy nighttime sound-light shows, and walk along the walls with sweeping views of old and new Jerusalem. Great for families.",
    fr: "Au Musée de la Tour de David, découvrez des expositions interactives sur les cités anciennes, des spectacles son et lumière nocturnes, et une promenade sur les remparts avec vue spectaculaire. Parfait en famille.",
    es: "En el Museo Torre de David encontrarás exposiciones interactivas sobre ciudades antiguas, shows nocturnos de luz y sonido, y paseos por las murallas con vistas espectaculares de Jerusalén. Ideal para familias."
  },
  details: {
    address: "שער יפו 2, ירושלים",
    addressEn: "2 Jaffa Gate, Jerusalem",
    addressFr: "2 Jaffa Gate, Jérusalem",
    addressEs: "2 Jaffa Gate, Jerusalén",
    phone: "+972-2-626-5333",
    hours: {
      he: {
        "א-ה": "10:00–17:00",
        "ו'": "10:00–15:00",
        "שבת": "10:30–16:00"
      },
      en: {
        "Sun–Thu": "10:00–17:00",
        "Fri": "10:00–15:00",
        "Sat": "10:30–16:00"
      }
    }
  },
  links: {
    website: "https://www.tod.org.il/",
    googleMaps: "https://www.google.com/maps?q=Tower+of+David+Museum+Jerusalem"
  }
},
{
  id: 13,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753434001/old-station_astb86.png",
  title: {
    he: "התחנה הישנה (First Station)",
    en: "The First Station – Jerusalem Old Train Station",
    fr: "La Première Gare – ancienne gare de Jérusalem",
    es: "La Primera Estación – antigua estación de tren de Jerusalén"
  },
  category: {
    he: "בילויים",
    en: "Leisure",
    fr: "Loisirs",
    es: "Ocio"
  },
  summary: {
    he: "מתחם היסטורי מתחדש ליד ימין משה – הופעות, מסעדות, פינות ישיבה ואווירה תרבותית עירונית.",
    en: "A historic redeveloped complex near Yemin Moshe – concerts, restaurants, seating corners and urban cultural vibes.",
    fr: "Un site historique rénové près de Yemin Moshe – concerts, restaurants, coins détente et ambiance urbaine culturelle.",
    es: "Complejo histórico renovado junto a Yemin Moshe – conciertos, restaurantes, rincones de descanso y ambiente urbano cultural."
  },
  content: {
    he: "התחנה הראשונה הייתה נמל הרכבת הראשון של ירושלים, כיום הפכה למתחם בילוי עם הופעות חוצות, שוק אוכל, סדנאות לילדים ובתי קפה. מקום אידיאלי לבילוי ערב או סופשבוע מהנה לכל המשפחה.",
    en: "Jerusalem’s original train station has been transformed into a lively leisure venue featuring outdoor concerts, food markets, workshops for kids, and cafés. Ideal for an evening or weekend family outing.",
    fr: "La première gare de Jérusalem a été convertie en un lieu de loisirs animé avec concerts en plein air, marché de nourriture, ateliers enfants et cafés. Idéal en soirée ou le week-end en famille.",
    es: "La estación de tren original de Jerusalén se ha convertido en un espacio de ocio con conciertos al aire libre, mercado de comida, talleres infantiles y cafés. Perfecto para una tarde o fin de semana familiar."
  },
  details: {
    address: "רחוב יואל משה סלומון 9, ירושלים",
    addressEn: "9 Yoel Moshe Salomon St, Jerusalem",
    addressFr: "9 Yoel Moshe Salomon St, Jérusalem",
    addressEs: "9 Yoel Moshe Salomon St, Jerusalén",
    },
  links: {
    googleMaps: "https://www.google.com/maps?q=First+Station+Jerusalem"
  }
},
{
  id: 14,
  image: "https://res.cloudinary.com/dp3vi9xno/image/upload/v1753434038/mamila_nwkvj0.png",
  title: {
    he: "ממילא – השדרה שבין חדש לישן",
    en: "Mamilla Avenue – Between Old & New",
    fr: "Avenue Mamilla – entre moderne et ancien",
    es: "Avenida Mamilla – entre lo nuevo y lo antiguo"
  },
  category: {
    he: "קניות",
    en: "Shopping",
    fr: "Shopping",
    es: "Compras"
  },
  summary: {
    he: "שדרה מקסימה בירושלים המשקיפה לעבר חומות העיר העתיקה, עם חנויות, גלריות, בתי קפה ואירועי רחוב.",
    en: "A charming Jerusalem promenade overlooking the Old City walls, with shops, galleries, cafés and street events.",
    fr: "Une promenade charmante à Jérusalem avec vue sur les remparts de la vieille ville, boutiques, cafés et animations de rue.",
    es: "Una avenida encantadora en Jerusalén con vistas a las murallas de la Ciudad Vieja, tiendas, galerías, cafés y eventos callejeros."
  },
  content: {
    he: "ממילא היא שדרה מתחדשת ששוכנת בין העיר החדשה לעיר העתיקה, ומשלבת שופינג ברמות בינלאומיות, אירועים תרבותיים והזדמנות להנות מנוף של העיר העתיקה. השדרה מלאה בגלריות, דוכני אוכל, מופעי רחוב ואופציה למנוחה נעימה עם קפה מול הנוף.",
    en: "Mamilla is a rejuvenated pedestrian promenade between new and old Jerusalem, blending upscale shopping, street performances, galleries and clear views of the Old City. Enjoy culture, coffee, and leisurely browsing along this vibrant avenue.",
    fr: "Mamilla est une promenade piétonne rénovée entre la vieille et la nouvelle Jérusalem, alliant boutiques de luxe, spectacles de rue, galeries d’art et vue sur la vieille ville. Ambiance culturelle et promenade relaxante.",
    es: "Mamilla es una avenida peatonal renovada entre la ciudad nueva y antigua de Jerusalén, con tiendas de lujo, actuaciones callejeras, galerías y vistas a la Ciudad Vieja. Ideal para un paseo cultural y relajado."
  },
  details: {
    address: "שדרות ממילא, ירושלים",
    addressEn: "Mamilla Avenue, Jerusalem",
    addressFr: "Mamilla Avenue, Jérusalem",
    addressEs: "Mamilla Avenue, Jerusalén",
  },
  links: {
    googleMaps: "https://www.google.com/maps?q=Mamilla+Avenue+Jerusalem"
  }
}
];

// Function to get all unique categories from blog posts
export const getCategories = (language) => {
  const categories = blogPosts.map(post => post.category[language]);
  return [...new Set(categories)];
};

export const BlogContext = createContext()

export const useBlog = () => useContext(BlogContext)